import { css, keyframes } from "styled-components";

/** Common surfaces for statistics and accounting, independent of card content. */
export const statPanelSurface = {
	minWidth: 0,
	boxSizing: "border-box",
	border: "1px solid #e1e6ef",
	borderRadius: "12px",
	background: "#fff",
	boxShadow: "none",
} as const;

export const statFilterSurface = {
	background: statPanelSurface.background,
	border: statPanelSurface.border,
	borderRadius: statPanelSurface.borderRadius,
	boxShadow: statPanelSurface.boxShadow,
} as const;

const refreshSpin = keyframes`to { transform: rotate(360deg); }`;

/** Used by refresh and other icon actions in card headers. */
export const statActionButtonStyles = css`
	display: inline-flex; align-items: center; justify-content: center; flex-shrink: 0;
	width: 32px; height: 32px; box-sizing: border-box; padding: 0;
	border: 1px solid #e1e6ef; border-radius: 6px; background: #fff; color: #667085; cursor: pointer;
	&:hover:not(:disabled) { background: #f5f7fa; color: #344054; }
	&:disabled { opacity: .5; cursor: default; }
	&[aria-busy="true"] svg, &[data-busy="true"] svg { animation: ${refreshSpin} 1s linear infinite; }
	&:focus-visible { outline: 2px solid #6374d9; outline-offset: 3px; }
	@media (prefers-reduced-motion: reduce) { svg { animation: none !important; } }
`;
